module.exports = __webpack_public_path__ + "img/Location.45f0f6c.svg";